import { ILinkProps, Link as LinkBase } from './Link';
import { LinkWrapper } from './_Wrapper/LinkWrapper';

interface INestedComponents {
  Wrapper: typeof LinkWrapper;
}

export const Link = LinkBase as unknown as React.ForwardRefExoticComponent<
  ILinkProps & React.RefAttributes<HTMLAnchorElement>
> &
  INestedComponents;

Link.Wrapper = LinkWrapper;
